import styled from 'styled-components';

const StyledOuter = styled.div<{ $top: number; $animateTop: boolean }>`
	position: absolute;
	top: ${(props) => `${props.$top}px`};
	bottom: 240px;
	right: 0;
	width: 100px;
	z-index: 10;
	pointer-events: none;
	transition: ${({ $animateTop }) =>
		$animateTop ? 'top 0.3s ease 0.1s' : 'none'};
`;

const StyledSlide = styled.div`
	position: absolute;
	inset: 0;
	opacity: 0;
	transform: translateX(200%);
	transition:
		transform 0.3s ease 0.1s,
		opacity 0.3s ease 0.1s;

	&.keys-appear {
		opacity: 0;
		transform: translateX(200%);
	}

	&.keys-appear-active,
	&.keys-appear-done {
		opacity: 1;
		transform: translateX(0);
	}

	&.keys-enter {
		opacity: 0;
		transform: translateX(200%);
	}

	&.keys-enter-active,
	&.keys-enter-done,
	&.keys-exit {
		opacity: 1;
		transform: translateX(0);
	}

	&.keys-exit-active {
		transform: translateX(200%);
		opacity: 0;
	}

	&.keys-exit-done {
		opacity: 0;
		transform: translateX(200%);
	}
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	right: 30px;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	row-gap: 20px;
	user-select: none;
	pointer-events: none;
`;

export { StyledContainer, StyledOuter, StyledSlide };
